import React from "react";
import logoIcon from "../../assets/images/logo/icon.png";
import "../GlobalApiLoader/GlobalApiLoader.scss";
import "./BrandedLoader.scss";

export type BrandedLoaderProps = {
  message?: string;
  fullscreen?: boolean;
  dark?: boolean;
  className?: string;
};

const BrandedLoader: React.FC<BrandedLoaderProps> = ({
  message = "Loading",
  fullscreen = true,
  dark = false,
  className = "",
}) => {
  const overlayClass = [
    "global-api-loader-overlay",
    "branded-loader",
    "notranslate",
    fullscreen ? "branded-loader--fullscreen" : "branded-loader--embedded",
    dark ? "global-api-loader-overlay--dark" : "",
    className,
  ]
    .filter(Boolean)
    .join(" ");

  return (
    <output className={overlayClass} aria-busy="true" aria-live="polite">
      <div className="global-api-loader-card">
        <div className="global-api-loader-visual" aria-hidden="true">
          <span className="global-api-loader-orbit global-api-loader-orbit--outer" />
          <span className="global-api-loader-orbit global-api-loader-orbit--inner" />
          <span className="global-api-loader-glow" />
          <div className="global-api-loader-core">
            <img
              src={logoIcon}
              alt=""
              className="global-api-loader-logo"
              width={36}
              height={36}
              decoding="async"
            />
          </div>
        </div>

        <p className="global-api-loader-text">
          <span className="global-api-loader-text-label">{message}</span>
        </p>
      </div>
    </output>
  );
};

export default BrandedLoader;
